/* eslint-disable */
import styled from 'styled-components';
import { FiSearch } from "react-icons/fi";
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
`;

export const SearchIcon = styled(FiSearch)`
  margin-left: -30px;
`;